export default function createAhoyEvent(email) {

  let data;
  if (typeof optimizely !== 'undefined') {
    data = optimizely.get('state').getVariationMap()
  } else {
    data = {}
  }
  const optimizelyExperimentData = Object.keys(data).map(k => ({'experimentId': k, 'variationId': data[k].id}))
  ahoy.start();
  ahoy.track('Subscription Conversion', {
    url: window.location.pathname,
    email: email,
    OptimizelyExperimentData: optimizelyExperimentData
  })
}
